import React from "react";
import { DefectImageHeader } from "./physical-ai/defect-image/DefectImageSkin";
import { SensorCarlineHeader } from "./physical-ai/sensor-carline/SensorCarlineSkin";
import { VideoAugmentationHeader } from "./physical-ai/video-augmentation/VideoAugmentationSkin";
import { LAUNCHABLE_SKIN, type LaunchableSkin } from "./registry";

interface SkinHeadingProps {
  skin: LaunchableSkin | null;
}

export const SkinHeading: React.FC<SkinHeadingProps> = ({ skin }) => {
  switch (skin) {
    case LAUNCHABLE_SKIN.PHYSICAL_AI_SENSOR_CARLINE:
      return <SensorCarlineHeader />;
    case LAUNCHABLE_SKIN.PHYSICAL_AI_DEFECT_IMAGE:
      return <DefectImageHeader />;
    case LAUNCHABLE_SKIN.PHYSICAL_AI_VIDEO_AUGMENTATION:
      return <VideoAugmentationHeader />;
    default:
      return null;
  }
};
